<div class="">
    <div class="page-content">
        <h2 class="heading7">Packing Slip</h2>
        <!-- ============ Customer Detail ============ -->
        <mat-card class="my-4">
            <mat-card-content>
                <!-- <h2 class="heading8">
                    Packing Slip
                </h2> -->
                <div class="entry-forms">
                    <div class="row">
                        <div class="col-md-3">
                            <label class="f-label">Customer Name</label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input type="text" matInput readonly>
                                <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <label class="f-label">Sales Order No.</label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input type="text" matInput readonly>
                                <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <label class="f-label">Date</label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input matInput [matDatepicker]="picker">
                                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <!-- ============ FOR NO PACKING SLIP ============ -->
                    <!-- <div class="row">
                        <div class="col-md-12">
                            <div class="noPS text-center">
                                <img src="" alt="" class="">
                                <p class="">No Packing Slip!</p>
                            </div>
                        </div>
                    </div> -->
                    <div class="row mt-2 mb-3">
                        <div class="col-md-12">
                            <div class="d-flex">
                                <div class="d-flex me-4">
                                    <span class="ps-salesOrderNo">SO-00248192</span>
                                    <span class="ps-salesOrderNoDelete d-flex">
                                        <mat-icon class="me-1">close</mat-icon>    
                                        <span>Remove</span>
                                    </span>
                                </div>
                                <div class="d-flex me-4">
                                    <span class="ps-salesOrderNo">SO-00248192</span>
                                    <span class="ps-salesOrderNoDelete d-flex">
                                        <mat-icon class="me-1">close</mat-icon>    
                                        <span>Remove</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 tabledesign expandableTable">
                            <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8">
                                <ng-container matColumnDef="arrow">
                                    <th mat-header-cell *matHeaderCellDef class="text-center"> &nbsp; </th>
                                    <td mat-cell *matCellDef="let element" class="text-center">
                                        <button mat-icon-button aria-label="expand row"
                                            (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
                                            <mat-icon *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>
                                            <mat-icon *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="package_no">
                                    <th mat-header-cell *matHeaderCellDef> Package No. </th>
                                    <td mat-cell *matCellDef="let element">
                                        <div class="mt-1">
                                            <mat-form-field class="field-bottom-0 mb-1" appearance="outline">
                                                <input type="text" matInput readonly>
                                            </mat-form-field>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="package_type">
                                    <th mat-header-cell *matHeaderCellDef> Package Type </th>
                                    <td mat-cell *matCellDef="let element">
                                        <div class="mt-1">
                                            <mat-form-field class="field-bottom-0 mb-1" appearance="outline">
                                                <input type="text" matInput readonly>
                                                <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                            </mat-form-field>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="units">
                                    <th mat-header-cell *matHeaderCellDef> Units </th>
                                    <td mat-cell *matCellDef="let element">
                                        <div class="mt-1">
                                            <mat-form-field class="field-bottom-0 mb-1" appearance="outline">
                                                <input type="text" matInput readonly>
                                                <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                            </mat-form-field>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="total_weights">
                                    <th mat-header-cell *matHeaderCellDef> Total Weights </th>
                                    <td mat-cell *matCellDef="let element">
                                        <div class="mt-1">
                                            <mat-form-field class="field-bottom-0 mb-1" appearance="outline">
                                                <input type="text" matInput readonly>
                                            </mat-form-field>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="selected_items">
                                    <th mat-header-cell *matHeaderCellDef> Selected Items </th>
                                    <td mat-cell *matCellDef="let element">
                                        <mat-chip class="fs-8">30</mat-chip>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="action">
                                    <th mat-header-cell *matHeaderCellDef class="text-center"> &nbsp; </th>
                                    <td mat-cell *matCellDef="let element" class="text-center">
                                        <div class="d-flex justify-content-center">
                                            <i-feather class="t-icon pointer me-2" name="trash-2"></i-feather>
                                            <mat-icon class="pointer text-primary">add_box</mat-icon>
                                        </div>
                                    </td>
                                </ng-container>

                                <!-- Expanded Content -->
                                <ng-container matColumnDef="expandedDetail">
                                    <td mat-cell *matCellDef="let element"
                                        [attr.colspan]="columnsToDisplayWithExpand.length">
                                        <div class="example-element-detail tExpend-detail"
                                            [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">

                                            <div class="tabledesign">
                                                <table mat-table [dataSource]="dataSource1" class="mat-elevation-z8">
                                                    <ng-container matColumnDef="sno">
                                                        <th mat-header-cell *matHeaderCellDef class="text-center"> S.
                                                            No. </th>
                                                        <td mat-cell *matCellDef="let element" class="text-center">
                                                            1
                                                        </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="item_no">
                                                        <th mat-header-cell *matHeaderCellDef> Item No. </th>
                                                        <td mat-cell *matCellDef="let element"> IT-0001 </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="item_description">
                                                        <th mat-header-cell *matHeaderCellDef> Item Description </th>
                                                        <td mat-cell *matCellDef="let element"> Item Description </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="uom">
                                                        <th mat-header-cell *matHeaderCellDef> UOM </th>
                                                        <td mat-cell *matCellDef="let element"> Nos </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="ordered_qty">
                                                        <th mat-header-cell *matHeaderCellDef class="text-end"> Ordered
                                                            Qty. </th>
                                                        <td mat-cell *matCellDef="let element" class="text-end"> 100
                                                        </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="selected_qty">
                                                        <th mat-header-cell *matHeaderCellDef> Selected Qty. </th>
                                                        <td mat-cell *matCellDef="let element">
                                                            <div class="mt-1">
                                                                <mat-form-field class="field-bottom-0 mb-1"
                                                                    appearance="outline">
                                                                    <input type="text" matInput readonly>
                                                                </mat-form-field>
                                                            </div>
                                                        </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="select_items">
                                                        <th mat-header-cell *matHeaderCellDef class="text-center">
                                                            Select Items </th>
                                                        <td mat-cell *matCellDef="let element" class="text-center">
                                                            <mat-checkbox></mat-checkbox>
                                                        </td>
                                                    </ng-container>

                                                    <tr mat-header-row *matHeaderRowDef="columnsToDisplay1"></tr>
                                                    <tr mat-row *matRowDef="let row; columns: columnsToDisplay1;"></tr>
                                                </table>

                                            </div>

                                        </div>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
                                <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;"
                                    class="example-element-row"
                                    [class.example-expanded-row]="expandedElement === element"
                                    (click)="expandedElement = expandedElement === element ? null : element">
                                </tr>
                                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
                                    class="example-detail-row"></tr>
                            </table>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-md-5">
                            <label class="f-label">Notes</label>
                            <mat-form-field class="full-width" appearance="outline">
                                <textarea matInput placeholder="Write your notes" rows="4"></textarea>
                                <mat-hint>Maximum characters limit: 250</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    
  <div class="mt-2 footer">
    <div class="">
      <button #buttonSave mat-raised-button color="primary">
        Save
      </button>
      <button class="me-2" #buttonCancel mat-raised-button>
        Cancel
      </button>
    </div>
  </div>

</div>